import { Breadcrumbs, Link, Typography } from '@mui/material';
import React from 'react'
import { Container, Col, Row, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import "../../../Assets/css/mjstatic.css"
import { useSelector } from 'react-redux';
import { Address_details, Email_details, client_name } from '../../../Helpers/request';
import RepairImg1 from '../../../Assets/images/eb-repair-img/repair4.jpg'
import RepairImg2 from '../../../Assets/images/eb-repair-img/repair3.jpg'
import RepairImg3 from '../../../Assets/images/eb-repair-img/repair2.jpg'


const Repairs = () => {
    const Email_details_link = Email_details.link
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>
            <div className="rcs_ringsetting_section eb_repair_Section mt-3">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb m-0 mb-md-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Repairs</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div className="rcs_privacy_content mt-4 mt-lg-4 mt-md-4 mt-sm-0 mt-xs-0 mb-0">
                                <h1>Repairs</h1>
                                {/* <h2>Introduction and Overview</h2> */}
                                <p>At Ebenezer Jewelry Repair Atelier LLC, we understand that jewelry holds not only monetary value but also sentimental worth. Whether it's a family heirloom or your favorite piece, we are here to ensure your jewelry stays as brilliant as the day you first received it.</p>
                            </div>
                        </Col>
                        
                    </Row>
                    <Row className='eb_repair_margin_top_bottom'>
                    <Col sm={12} md={12} lg={6} className='eb_order1'>
                        <div className='rcs_privacy_content'>
                            <h2>Our Jewelry Repair Expertise :</h2>
                                <ul className='eb_repairs_list'>
                                    <li>
                                        <p><strong>Ring Resizing: </strong> Does your cherished ring no longer fit? Our skilled jewelers can resize it, so it sits comfortably on your finger once more.</p>
                                    </li>
                                    <li><p><strong>Stone Replacement: </strong>Lost a gemstone from your ring or necklace? We can match and replace it seamlessly.</p></li>
                                    <li><p><strong>Prong Re-tipping: </strong>Secure your precious stones with prong re-tipping, ensuring they remain safe and dazzling.</p></li>
                                    <li><p><strong>Chain Repair: </strong> Broken necklace or bracelet? We'll mend it with precision, so you can wear it confidently.</p></li>
                                    <li><p><strong>Cleaning and Polishing: </strong>Restore the shine and luster of your jewelry with our professional cleaning and polishing services.</p></li>
                                    <li><p><strong>Clasp Replacement: </strong>Ensure your jewelry stays securely fastened with our clasp replacement service.</p></li>
                                    <li><p><strong>Earring Repair: </strong>From stud replacements to fixing hinges, we'll make your earrings look good as new.</p></li>
                                </ul>
                            </div>
                        </Col>
                        <Col sm={12} md={12} lg={6} className='align-items-center d-flex eb_order2'>
                            <div className='text-center eb_repair_img_box m-auto'>
                                <Image src={RepairImg1} alt="Repair Image" className='img-fluid first_imggg'/>
                            </div>
                        </Col>
                    </Row>
                    <Row className='eb_repair_margin_top_bottom'>
                    <Col sm={12} md={12} lg={6} >
                            <div className='text-center eb_repair_img_box'>
                                <Image src={RepairImg2} alt="Repair Image" className='img-fluid'/>
                            </div>
                        </Col>
                    <Col sm={12} md={12} lg={6}>
                        <div className='rcs_privacy_content'>
                           
                            <h2>Why Choose Us for Jewelry Repair:</h2>
                                <ul className='eb_repairs_list'>
                                    <li>
                                        <p><strong>Experienced Craftsmanship: </strong> Our skilled jewelers have years of experience in handling a wide range of jewelry repair tasks, ensuring top-quality work.</p>
                                    </li>
                                    <li><p><strong>Attention to Detail:</strong>We treat each piece of jewelry with the utmost care, paying attention to even the smallest of details.</p></li>
                                   <li><p><strong>Quality Materials: </strong>We use high-quality materials and gemstones to match or exceed the original, ensuring longevity.</p></li>
                                   <li><p><strong>Timely Service: </strong> We understand the importance of your jewelry and strive to provide prompt service without compromising on quality.</p></li>
                                   <li><p><strong>Competitive Pricing: </strong>We offer fair and transparent pricing for all our repair services.</p></li>
                                   <li><p><strong>Customer Satisfaction: </strong> Your satisfaction is our priority. We are not satisfied until you are delighted with the results.</p></li>
                                </ul>
                            </div>
                        </Col>
                        
                    </Row>
                    <Row className='eb_repair_margin_top_bottom'>
                    
                    <Col sm={12} md={12} lg={6} className='eb_order1'>
                        <div className='rcs_privacy_content'>
                        <h2>How it Works:</h2>
                                <ul className='eb_repairs_list'>
                                <li><p><strong>Evaluation: </strong>Bring your jewelry to us, and we'll assess the repair needs and provide you with an estimate.</p></li>
                                   <li><p><strong>Approval: </strong>Once you approve the estimate, we will begin the repair process.</p></li>
                                   <li><p><strong>Skilled Repair: </strong>Our expert jewelers will skillfully repair your jewelry, ensuring it's restored to its original glory.</p></li>
                                   <li><p><strong>Quality Check: </strong>Each piece undergoes a rigorous quality check to ensure it meets our high standards.</p></li>
                                   <li><p><strong>Delivery: </strong>Your repaired jewelry will be returned to you, ready to be worn and cherished once again.</p></li>
                                </ul>
                            </div>
                        </Col>
                        <Col sm={12} md={12} lg={6} className='align-items-center d-flex eb_order2'>
                            <div className='text-center eb_repair_img_box'>
                                <Image src={RepairImg3} alt="Repair Image" className='img-fluid'/>
                            </div>
                        </Col>
                    </Row>
                    <Row className='eb_repair_margin_top_bottom'>
                    <Col sm={12} md={12} lg={12}>
                        <div className='rcs_privacy_content'>
                        <p>Your jewelry is a reflection of your personality and style. Trust Ebenezer Jewelry Repair Atelier LLC to handle it with the care and expertise it deserves. Contact us today to schedule your repair or visit our store at <br></br></p>
                                <p><NavLink  to="#" onClick={()=> window.open(Address_details.link, "_blank")}  ><span className="mt-6">{Address_details.textLine1}</span> <br></br> <span>{Address_details.textLine2}</span></NavLink>.</p>
                                <p>Let us restore the sparkle to your treasured pieces!</p>
                        </div>
                        </Col>
                    </Row>
                    
                </Container>
            </div>
        </div>
    )
}

export default Repairs;